import { SpEditorProvider } from '@/features/screenplay/components/editor/SpEditorProvider'
import { WorkspaceLayout } from '@/features/workspace'
import React from 'react'
import SbSidebar from '../components/SbSidebar'
import SbOptionBar from '../components/SbOptionBar'

import StoryboardMainContent from '../components/StoryboardMainContent'
import HeadlessSpEditor from '@/features/shared/component/HeadlessSpEditor'

const StoryboardPage = () => {
    return (
        <WorkspaceLayout
            ProviderWrapper={({ children }) => <SpEditorProvider>{children}</SpEditorProvider>}
            SidebarComponent={<SbSidebar />}
            optionBar={<SbOptionBar />}
        >
            <HeadlessSpEditor />
            <StoryboardMainContent />
        </WorkspaceLayout>
    )
}

export default StoryboardPage
